import React, { useContext, useEffect, useState } from 'react';

import {
    Grid,
} from '@material-ui/core';

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';
import { UserContext } from '../../../../contexts';

import { AccountReceivableForm } from './AccountReceivableForm'
import { TaxForm } from './TaxForm'

import { RequestStatus, ApplicationRoles } from '../../../../../helpers';

import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: 20
    }
}));

export const AccountReceivableTab = (props) => {
    const classes = useStyles();

    const { 
        isUserInRole, 
        isUserInRoles 
    } = useContext(UserContext);

    const {
        state,
    } = useContext(CustomerRequestContext);

    const { 
        values,
        isSubmitting,
        setFieldValue
    } = useContext(TabsContext);

    const [disabled, setDisabled] = useState(false);
    useEffect(() => {
        setDisabled(isSubmitting
            || !(
                (state.request.status === RequestStatus.AccountReceivableApproval
                    && isUserInRole(ApplicationRoles.AccountReceivable))                
            )
        );
    }, [isSubmitting, state.request.status])

    useEffect(() => {
        if (
            state.taxCategories &&
            state.taxCategories.length &&
            values &&
            values.accountReceivable &&
            (
                !values.accountReceivable.taxCategories ||
                values.accountReceivable.taxCategories.length === 0
            )
        ){
            const formTaxCategories = state.taxCategories.map(x =>
                ({
                    taxCategoryName: x.name,
                    taxClassificationName: "",
                    countryKey: x.countryKey
                })
            );
            setFieldValue("accountReceivable.taxCategories", formTaxCategories);
        }
    },[state.taxCategories]);

    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xl={12} xs={12} md={12}>
                    <AccountReceivableForm disabled={disabled}/>
                </Grid>
                <Grid item xl={12} xs={12} md={12}>
                    <TaxForm disabled={disabled}/>
                </Grid>
            </Grid>
        </div>
    );
}


